import { Controller } from "@hotwired/stimulus"
import { swapToSpinner, restoreButton } from "./helpers/button_loading"

export default class extends Controller {
  static values = { appointmentId: Number }

  async setDelay(event) {
    const minutes = event.params.minutes
    const button = event.currentTarget
    const restore = swapToSpinner(button, { label: `Sending +${minutes} min delay` })

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const body = new URLSearchParams({
        status: "running_late",
        delay_minutes: minutes
      })

      const response = await fetch(`/appointments/${this.appointmentIdValue}/status`, {
        method: "PATCH",
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": token,
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: body.toString()
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
        restoreButton(button, restore)
      } else {
        restoreButton(button, restore)
      }
    } catch {
      restoreButton(button, restore)
    }
  }
}
